module.exports = __webpack_public_path__ + "assets/Cash.40d95c38.svg";